var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnReportLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 15C13.25 13.4812 14.4812 12.25 16 12.25H28C29.5188 12.25 30.75 13.4812 30.75 15V29C30.75 30.5188 29.5188 31.75 28 31.75H16C14.4812 31.75 13.25 30.5188 13.25 29V15ZM16 13.75C15.3096 13.75 14.75 14.3096 14.75 15V29C14.75 29.6904 15.3096 30.25 16 30.25H28C28.6904 30.25 29.25 29.6904 29.25 29V15C29.25 14.3096 28.6904 13.75 28 13.75H16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 18C17.25 17.5858 17.5858 17.25 18 17.25H26.5C26.9142 17.25 27.25 17.5858 27.25 18C27.25 18.4142 26.9142 18.75 26.5 18.75H18C17.5858 18.75 17.25 18.4142 17.25 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 22C18.25 21.5858 18.5858 21.25 19 21.25H26C26.4142 21.25 26.75 21.5858 26.75 22C26.75 22.4142 26.4142 22.75 26 22.75H19C18.5858 22.75 18.25 22.4142 18.25 22Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 26C17.25 25.5858 17.5858 25.25 18 25.25H26.5C26.9142 25.25 27.25 25.5858 27.25 26C27.25 26.4142 26.9142 26.75 26.5 26.75H18C17.5858 26.75 17.25 26.4142 17.25 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnReportLight);
export default __webpack_public_path__ + "static/media/btn_report_light.faa5eb90b20e7d8dcd62bd55fd14e00b.svg";
export { ForwardRef as ReactComponent };